import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Subtitle } from '../forms/Title';
import { Divider } from '@mui/material';
import AreaSelector from '../forms/AreaSelector';

const DeliveryAreaSection = () => {
  const styles = {
    layout: {
      paddingTop: {
        xs: 'calc(2vh)',
        sm: 'calc(4vh)',
        md: 'calc(4vh)',
        lg: 'calc(2vh)',
      },
      marginLeft: {
        xs: 'calc(2vw)',
        sm: 'calc(2vw)',
        md: 'calc(4vw)',
        lg: 'calc(6vw)',
      },
      paddingLeft: {
        xs: 'calc(2vw)',
        sm: 'calc(2vw)',
        md: 'calc(4vw)',
        lg: 'calc(6vw)',
      },
    },
    title: {
      marginTop: '10vh',
      marginRight: {
        xs: 'calc(1vw)',
        sm: 'calc(2vw)',
        md: 'calc(2vw)',
        lg: 'calc(6vw)',
      },
      paddingRight: {
        xs: 'calc(2vw)',
        sm: 'calc(2vw)',
        md: 'calc(2vw)',
        lg: 'calc(6vw)',
      },
    },
  };

  return (
    <Grid
      container
      rowSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
      columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
      id="location"
    >
      <Grid item xs={12}>
        <Box sx={styles.layout}>
          <Grid container>
            <Grid item xs={12} sx={styles.title}>
              <Subtitle title="Choose your delivery area" />
              <Divider />
            </Grid>
          </Grid>
        </Box>
        <AreaSelector />
      </Grid>
    </Grid>
  );
};

export default DeliveryAreaSection;
